import _implicitStylesheets from "./privacyBanner.css";
import _implicitScopedStylesheets from "./privacyBanner.scoped.css?scoped=true";
import _adsIcon from "ads/icon";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="text-container${0}"${2}><span type-style="body-3" class="bolded${0}"${2}>${"t2"}</span><span type-style="body-3"${3}>${"t4"}</span></div>`;
const stc0 = {
  classMap: {
    "container": true
  },
  key: 0
};
const stc1 = {
  props: {
    "size": "medium",
    "symbol": "info"
  },
  key: 1
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element} = $api;
  return [api_element("div", stc0, [api_custom_element("ads-icon", _adsIcon, stc1), api_static_fragment($fragment1, 3, [api_static_part(2, null, api_dynamic_text($cmp.labels.title)), api_static_part(4, null, api_dynamic_text($cmp.labels.message))])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3p0gg44dr6i";
tmpl.legacyStylesheetToken = "undefined-_privacyBanner";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
